<template>
    <div class="drop-down" :class="{ open: isOpen, white: white }" v-click-outside="close">
        <button @click.prevent="toggle">{{ label }}</button>
        <div class="menu">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,
    name: 'base-dropdown-menu',
    props: {
        label: {
            type: String,
            description: 'Menu label',
        },
        white: {
            type: Boolean,
            description: 'White label style'
        }
    },
    data() {
        return {
            isOpen: false
        }
    },
    methods: {
        toggle() {
            this.isOpen = !this.isOpen
        },
        close() {
            this.isOpen = false
        }
    }
};
</script>

<style scoped lang="scss">
    .drop-down {
        position: relative;
        display: inline-block;
        &.open {
            button {
                &:after {
                    transform: rotate(180deg);
                }
            }
            .menu {
                display: inline-block;
            }
        }
        .menu {
            display: none;
            background: #FFFFFF;
            min-width: 138px;
            box-shadow: 0 4px 20px rgb(32 0 51 / 10%);
            border-radius: 20px;
            position: absolute;
            left: -2px;
            top: 40px;
            padding: 0.5rem 0;
            margin: 0.125rem 0 0;
            z-index: 1;
        }
        button {
            font-weight: 500;
            font-size: 20px;
            color: #200033;
            border: none;
            background: transparent;
            position: relative;
            &:after {
                content: '';
                display: inline-block;
                background-image: url('/img/dropdown_arrow.svg');
                background-repeat: no-repeat;
                background-size: 12px 12px;
                width: 12px;
                height: 13px;
                transition: transform .2s ease;
                margin-left: 11px;
                position: relative;
                top: 3px;
            }
        }
        &.white {
            button {
                color: #fff;
                &:after {
                    background-image: url('/img/dropdown_arrow_white.svg');
                }
            }
        }
    }
</style>

